import { atom } from 'jotai';

export const isTemplateDetailsModalOpenAtom = atom(false);
